module.exports = __webpack_public_path__ + "img/center-info-structure7-1.0725d28d.png";